import { useUploadContext } from "../context/UploadContext";
export default function useUploadQueue() {
  return useUploadContext();
}